//判断访问终端
var browser = {
    versions:function(){
        var u = navigator.userAgent,
            app = navigator.appVersion;
        return {
            trident: u.indexOf('Trident') > -1, //IE内核
            presto: u.indexOf('Presto') > -1, //opera内核
            webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
            iPhone: u.indexOf('iPhone') > -1 , //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
            webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
            weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
            qq: u.match(/\sQQ/i) == "qq" //是否QQ
        };
    }()
}
//先用设备检测
function deviceCheck(){
    var userAgent = navigator.userAgent;
    //平台、设备和操作系统
    var system = {
        win : false,
        mac : false,
        xll : false
    };
    //检测平台
    var p = navigator.platform;
    system.win = p.indexOf("Win") == 0;
    system.mac = p.indexOf("Mac") == 0;
    system.x11 = (p == "X11") || (p.indexOf("Linux") == 0);
    //跳转语句
    if(system.win||system.mac||system.xll){//pc
        return null;
    }else{//手机
        if(browser.versions.ios){
            return 'IOS';
        }
        if(browser.versions.android){
            return 'Android';
        }
    }
}

//IOS-Android
//获取APP类型
window.appType = '';
var dcType = deviceCheck();
if(dcType) window.appType = dcType;

import store from '../../vuex/store'
const app = {
    appType: window.appType,
    //拨打电话
    callphone(tel){
        //浏览器web
        if(!window.appType){
            window.location.href = 'tel:' + tel;
            return;
        }

        //IOS
        window.setupWebViewJavascriptBridge(function (bridge) {
            //IOS打电话
            bridge.callHandler('APP.makeCall', {'tel': tel});
        })

        //Android
        if(window.appType == 'Android' && typeof APP != 'undefined') {
            APP.makeCall(JSON.stringify({'tel': tel}))
        }
    },

    /**
     * APP交互
     */
    callHandler(param){
        //$('body').append('window.appType:' + window.appType + '!');

        //IOS
        window.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler(param.key, param.param || {}, function responseCallback(responseData) {
                param.callback && param.callback(responseData);
            })
        })

        //Android
        if(window.appType == 'Android' && typeof APP != 'undefined') {
            APP[param.key](JSON.stringify(param.param || {}));
        }
    },

    /**
     * APP返回上一级页面
     * */
    /**
     * preUrl -- '#/ask_price'
     * funKey -- 回调 字符串函数 例子：begin
     * itemKey -- 字符串参数 JSON.stringify({a: 'a1', b: 'b1'})
     */
    backPage(preUrl, funKey, itemKey = ''){
        let param = {
            preUrl: preUrl,
            fun: funKey,
            item: itemKey
        };
        if(typeof arguments[0] == 'object'){
            param = preUrl;
        }
        //完善url
        if(param.preUrl.indexOf('#') < 0) param.preUrl = '#' + param.preUrl;
        let src = param.preUrl;
        let funName = param.fun;
        let item = param.item || '';

        if(item){
            if(typeof item != 'string') item = JSON.stringify(item);
        }

        //url
        let testPath = store.state.testPath || '';
        let url = store.state.domain + testPath + '/' + src;
        let fun = funName + '(' + item + ')';

        //console.log(fun)

        //pc
        if(!window.appType){
            window.localStorage.setItem(funName, item);
            return;
        }


        //alert(JSON.stringify({'nextUrl': url, 'fun': fun, 'viewStatus': 'viewDidAppear'}))
        //IOS
        window.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('APP.InitFunToPage', {'nextUrl': url, 'viewStatus': 'viewDidAppear', 'fun': fun}, function responseCallback(responseData) {
                param.callback && param.callback();
            })
        })

        //Android
        if(window.appType == 'Android' && typeof APP != 'undefined') {
            APP.InitFunToPage(JSON.stringify({'nextUrl': url, 'viewStatus': 'viewDidAppear', 'fun': fun}))
        }
    },
    /**
     * APP返回上一级页面执行的全局函数
     * */
    /**
     * list -- {key: 'funName', fun: 'this.函数名'}
     * self -- 'this'
     */
    winFun(param){
        let self = param.self;
        for(let o of param.list){
            window[o.key] = function(item){
                if(isJSON(item)) item = JSON.parse(item);
                if(typeof item == 'undefined') item = '';
                self[o.fun] && self[o.fun](item);
            }
            //pc
            /*if(!window.appType){
                let str = localStorage.getItem(o.key);
                if(isJSON(str)) str = JSON.parse(str);
                self[o.fun] && self[o.fun](str);
            }*/
        }

        function isJSON(str) {
            if (typeof str == 'string') {
                try {
                    var obj=JSON.parse(str);
                    if(typeof obj == 'object' && obj ){
                        return true;
                    }else{
                        return false;
                    }

                } catch(e) {
                    //console.log('error：'+str+'!!!'+e);
                    return false;
                }
            }
            //console.log('It is not a string!')
        }
    },


    /**
     * APP-web  打开新页面跳转
     */
    /**
     * urlKey -- '/ask_price' //修改成param
     * selfKey -- 'this'
     * pathKey -- { path: '/ask_price' }
     * isNoPullRefresh -- true //跳转无下拉刷新的页面
     * */
    urlCommon(urlKey, selfKey, pathKey){
        let param = {
            url: urlKey,
            self: selfKey,
            path: pathKey || { path: urlKey },
        };
        if(typeof arguments[0] == 'object'){
            param = urlKey;
        }
        let url = param.url;
        let self = param.self;
        let path = param.path || { path: param.url };
        // 跳转无下拉刷新的页面
        // param.isNoPullRefresh;


        //pc
        if(!window.appType){
            self.$router.push(path);
            return;
        }

        let appKey = 'APP.UrlCommon';
        //if(param.isNoPullRefresh) appKey = 'APP.UrlCommonNoPullRefresh';
        let otherObj = {};
        if(param.isNoPullRefresh) otherObj.noPullRefresh = param.isNoPullRefresh;
        if(param.backJS) otherObj.backJS = param.backJS + '()';


        //url
        let testPath = store.state.testPath || '';
        let _url = store.state.domain + testPath + '/#' + url;
        let $t = '?';
        if(_url.indexOf('?') >= 0){
            $t = '&';
        }
        _url += $t + 'v=' + Math.ceil(Math.random()*99999999999);


        //对象
        let obj = {...{'url': _url, 'target': '_blank'}, ...otherObj};

        //IOS
        window.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler(appKey, obj, function responseCallback(responseData) {

            })
        })

        //Android
        if(window.appType == 'Android'){
            APP.UrlCommon(JSON.stringify(obj))
        }
    },


    /**
     * APP.navigationBarRightButtons  app头部右上角
     */
    /**
     * param.self -- 'this'
     * param.appFunName -- 按钮数组
     * param.prefix -- 方法名前缀
     * param.fun -- 本地方法名称默认appFun
     * */
    navigationBarRightButtons(param){
        let arr = [];
        for(let obj of param.appFunName){
            let funName = param.prefix + obj.key;
            //注册全局方法
            window[funName] = function () {
                param.self[param.fun || 'appFun'](obj.key);
            }
            obj['fun'] = param.prefix + obj.key + '()';
            arr.push(obj);
        }

        //ios
        window.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler(
                'APP.navigationBarRightButtons',
                arr,
                function responseCallback(responseData){

                }
            )
        })
        /*window.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler(
                'APP.navigationBarRightButtons',
                [
                    {title: '审核', fun: 'sale_details_fun_examine()'},
                    {title: '修改', fun: 'sale_details_fun_modify()'},
                    {title: '更多', fun: 'sale_details_fun_more()', url: 'https://h5.boss.360leiliang.com/test_erp/icon/ellipsis.png', type: 'img'}
                ],
                function responseCallback(responseData){

                }
            )
        })*/

        //Android
        if(window.appType == 'Android' && typeof APP != 'undefined') {
            APP.navigationBarRightButtons(JSON.stringify(arr));
        }
    },

    /**
     * APP.closeCurrentPage  关闭当前页面
     */
    closeCurrentPage(param = {}){
        //pc
        if(!window.appType){
            window.history.go(-1);
            return;
        }

        //ios
        window.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler(
                'APP.closeCurrentPage',
                function responseCallback(responseData){

                }
            )
        })

        //Android
        if(window.appType == 'Android' && typeof APP != 'undefined') {
            APP.closeCurrentPage();
        }
    },


    /**
     * APP download 【更新版本】
     */
    download(param){
        //pc
        if(!window.appType){
            alert('进app查看');
            return;
        }

        //IOS
        window.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler(param.key, param.param || {}, function responseCallback(responseData) {
                param.callback && param.callback(responseData);
            })
        })

        //Android
        if(window.appType == 'Android' && typeof APP != 'undefined') {
            let $android = store.state.appVersion.android;
            APP.showUpdateDialog(JSON.stringify({'url': $android.url}));
            //APP.showUpdateDialog(JSON.stringify({'forceUpdate': $android.forceUpdate,'log': $android.log,'versionName': $android.versionName, 'versionCode': $android.versionCode,'url': $android.url}));
        }
    },

    /**
     * 下载的url app通过url下载excel文件
     * 下载的回调函数
     * @param options
     */
    downloadAndShareExcelFile(url, callbackFunName){
        let fileUrl = url;
        let param = {
            'fileUrl': fileUrl,
            'callbackFunName': callbackFunName
        };
        //ios
        window.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler(
                'APP.DownloadAndShareExcelFile',
                param,
                function responseCallback(responseData){
                    //callback && callback(responseData)
                }
            )
        })

        //Android
        if(window.appType == 'Android' && typeof APP != 'undefined') {
            APP.DownloadAndShareExcelFile(JSON.stringify(param));
        }
    },

    /**
     * 注册JS函数给App调用
     * @param options
     */
    regJsFunForAppExecute(param){
        for(let obj of param.appFunName){
            let funName = param.prefix + obj.key;
            //注册全局方法
            if(!window[funName]){
                window[funName] = function () {
                    param.self[param.fun || 'appFun'](obj.key);
                }
            }
            obj['fun'] = param.prefix + obj.key + '()';
        }
    },



    /**
     * storage 本地存储
     */
    storage: {
        //设置缓存
        setItem(key, valueStr){
            if(typeof valueStr != 'string') valueStr = JSON.stringify(valueStr);
            //pc
            if(!window.appType){
                window.localStorage.setItem(key, valueStr);
                return;
            }

            let param = {'action': 'setItem', 'itemKey': key, 'itemValue': valueStr};
            //IOS
            window.setupWebViewJavascriptBridge(function (bridge) {
                bridge.callHandler('APP.Storage', param, function responseCallback(responseData) {

                })
            })

            //Android
            if(window.appType == 'Android' && typeof APP != 'undefined') {
                APP.Storage(JSON.stringify(param));
            }
        },
        //获取缓存
        getItem(key){
            return new Promise((resolve, reject) => {
                //pc
                if(!window.appType){
                    resolve(window.localStorage.getItem(key));
                    return;
                }

                let param = {'action': 'getItem', 'itemKey': key};
                //IOS
                window.setupWebViewJavascriptBridge(function (bridge) {
                    bridge.callHandler('APP.Storage', param, function responseCallback(responseData) {
                        resolve(responseData)
                    })
                })

                //Android
                if(window.appType == 'Android' && typeof APP != 'undefined') {
                    resolve(APP.Storage(JSON.stringify(param)));
                }
            })
        },
        //删除单独缓存
        removeItem(key){
            //pc
            if(!window.appType){
                window.localStorage.removeItem(key);
                return;
            }

            let param = {'action': 'removeItem', 'itemKey': key};
            //IOS
            window.setupWebViewJavascriptBridge(function (bridge) {
                bridge.callHandler('APP.Storage', param, function responseCallback(responseData) {

                })
            })

            //Android
            if(window.appType == 'Android' && typeof APP != 'undefined') {
                APP.Storage(JSON.stringify(param));
            }
        },
        //删除全部缓存
        clear(){
            //pc
            if(!window.appType){
                window.localStorage.clear();
                return;
            }

            let param = {'action': 'clear'};
            //IOS
            window.setupWebViewJavascriptBridge(function (bridge) {
                bridge.callHandler('APP.Storage', param, function responseCallback(responseData) {

                })
            })

            //Android
            if(window.appType == 'Android' && typeof APP != 'undefined') {
                APP.Storage(JSON.stringify(param));
            }
        }
    },


    /**
     * pasteBoard 剪切板
     */
    pasteBoard: {
        copy(text){
            return new Promise((resolve, reject) => {
                //pc
                if(!window.appType){
                    return;
                }


                let param = {'pasteText': text};
                //IOS
                window.setupWebViewJavascriptBridge(function (bridge) {
                    bridge.callHandler('APP.CopyToSystemPaste', param, function responseCallback(responseData) {
                        resolve(responseData)
                    })
                })

                //Android
                if(window.appType == 'Android' && typeof APP != 'undefined') {
                    resolve(APP.CopyToSystemPaste(JSON.stringify(param)));
                }
            })
        },
        read(){
            //pc
            if(!window.appType){
                return;
            }

            //IOS
            window.setupWebViewJavascriptBridge(function (bridge) {
                bridge.callHandler('APP.ReadSystemPasteText', function responseCallback(responseData) {
                    alert(responseData)
                })
            })

            //Android
            if(window.appType == 'Android' && typeof APP != 'undefined') {
                APP.ReadSystemPasteText();
            }
        }
    },


    /**
     * 扫描二维码
     */
    /**
     * id--唯一值
     * type--类型（1:二维码）
     * fun--函数名
     */
    startScanCode(param){
        let id = param.id || Math.ceil(Math.random() * 100000);
        let type = param.type || 1; //二维码
        let fun = param.fun;

        //pc
        if(!window.appType){

        }

        //IOS
        window.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('APP.StartScanCode', {id: id, type: type, 'fun': fun }, function responseCallback(responseData) {

            })
        })

        //Android
        if(window.appType == 'Android' && typeof APP != 'undefined') {

        }
    },
};
export default app;



// WEBPACK FOOTER //
// ./src/common/js/app.js